export const mockBanner = [
  {
    id: 1,
    title: '服务经济社会高质量发展',
    subtitle: '助力科学决策，智谋投资价值',
    image: '/static/lb1.png',
    link: '/'
  },
  {
    id: 2,
    title: '服务经济社会高质量发展',
    subtitle: '助力科学决策，智谋投资价值',
    image: '/static/lb2.png',
    link: '/services'
  }
]

export const mockNews = [
  {
    id: 1,
    title: '公司赴凉山州盐源县开展项目谋划储备及资金争取专题培训',
    summary: '受凉山州盐源县政府邀请，公司副总经理带队赴盐源县对接洽谈，并开展了为期一天的项目谋划储备及资金争取专项培训。',
    date: '2026-07-06',
    image: '/static/xwdt.png',
    category: '公司新闻'
  },
  {
    id: 2,
    title: '公司开展"全过程工程咨询风险防范"法律专题培训',
    summary: '面对行业发展新机遇、新挑战，公司始终坚持以高质量发展为导向，聚焦三大战略方向，稳步推进业务转型发展。',
    date: '2026-07-05',
    image: '/static/xwdt.png',
    category: '公司新闻'
  },
  {
    id: 3,
    title: '公司开展2026年"安全生产月"活动',
    summary: '今年6月是第25个全国"安全生产月"，主题为"人人讲安全、个个会应急——排查整治风险隐患"。',
    date: '2026-07-04',
    image: '/static/xwdt.png',
    category: '公司新闻'
  },
  {
    id: 4,
    title: '中国工程咨询协会关于抵制"内卷式"竞争的倡议',
    summary: '工程咨询行业是现代生产性服务业的重要组成部分，在扩大有效投资、推进中国式现代化建设方面发挥着不可替代的智力支撑作用。',
    date: '2026-07-03',
    image: '/static/xwdt.png',
    category: '行业资讯'
  },
  {
    id: 5,
    title: '国务院关于印发《城市更新"十五五"规划》的通知',
    summary: '城市是现代化建设的重要载体、人民幸福生活的重要空间。为贯彻落实党中央、国务院关于高质量推进城市更新的决策部署，制定本规划。',
    date: '2026-06-30',
    image: '/static/xwdt.png',
    category: '政策资讯'
  },
  {
    id: 6,
    title: '投资审批制度改革与工程咨询行业使命担当',
    summary: '国务院办公厅印发《关于深化投资审批制度改革的意见》，这是继2016年投资审批制度改革系列部署之后，中央层面对投资审批领域作出的又一次系统性顶层设计。',
    date: '2026-06-28',
    image: '/static/xwdt.png',
    category: '政策资讯'
  }
]

export const mockNewsDetail = {
  id: 1,
  title: '公司赴凉山州盐源县开展项目谋划储备及资金争取专题培训',
  content: `受凉山州盐源县政府邀请，公司党总支委员、副总经理张潇带队于6月24日赴盐源县对接洽谈，并在县会议中心开展了为期一天的项目谋划储备及资金争取专项培训。盐源县委常委、常务副县长陈明江，县委常委、县政府副县长严晓东出席专题培训会。

培训会上，公司专家团队围绕项目谋划储备、资金争取策略、投资项目可行性研究等内容进行了深入讲解，并与参会人员就实际工作中遇到的问题进行了互动交流。

此次培训旨在帮助盐源县相关部门提升项目谋划和资金争取能力，推动县域经济社会高质量发展。`,
  date: '2026-07-06',
  author: '新恒丰集团',
  image: '/static/xwdt.png',
  category: '公司新闻'
}

export const mockServices = [
  {
    id: 1,
    name: '项目策划及风险管理',
    subtitle: 'PROJECT PLANNING',
    description: '提供项目前期策划、可行性研究、风险管理等全方位服务，帮助客户精准定位项目价值，有效规避风险。',
    image: '/static/serve/serve1.png',
  },
  {
    id: 2,
    name: '工程咨询及监理',
    subtitle: 'ENGINEERING CONSULTING',
    description: '提供全过程工程咨询服务，包括项目管理、施工监理、质量控制等，确保项目顺利实施。',
    image: '/static/serve/serve2.png',
  },
  {
    id: 3,
    name: '人力资源管理',
    subtitle: 'HUMAN RESOURCES',
    description: '提供人力资源规划、招聘培训、绩效考核等专业服务，助力企业构建高效人才团队。',
    image: '/static/serve/serve3.png',
  },
  {
    id: 4,
    name: '造价咨询',
    subtitle: 'COST CONSULTING',
    description: '提供工程造价估算、预算编制、成本控制等服务，帮助客户实现投资效益最大化。',
    image: '/static/serve/serve4.png',
  },
  {
    id: 5,
    name: '招标代理',
    subtitle: 'BIDDING AGENCY',
    description: '提供招标方案设计、招标文件编制、评标组织等全过程招标代理服务，确保招投标公平公正。',
    image: '/static/serve/serve5.png',
  },
  {
    id: 6,
    name: '工程造价咨询',
    subtitle: 'ENGINEERING COST',
    description: '提供工程造价全流程咨询服务，包括投资估算、设计概算、施工图预算、竣工结算等。',
    image: '/static/serve/serve6.png',
  },
  {
    id: 7,
    name: '第三方评估咨询',
    subtitle: 'THIRD-PARTY EVALUATION',
    description: '提供独立第三方评估服务，包括项目后评价、绩效评估、风险评估等，为决策提供客观依据。',
    image: '/static/serve/serve7.png',
  }
]
export const fuwuServices = [
  {
    id: 1,
    name: '项目策划及风险管理',
    subtitle: 'PROJECT PLANNING',
    description: '提供项目前期策划、可行性研究、风险管理等全方位服务，帮助客户精准定位项目价值，有效规避风险。',
    image: '/static/fuwu/fw1.png',
  },
  {
    id: 2,
    name: '工程咨询及监理',
    subtitle: 'ENGINEERING CONSULTING',
    description: '提供全过程工程咨询服务，包括项目管理、施工监理、质量控制等，确保项目顺利实施。',
    image: '/static/fuwu/fw2.png',
  },
  {
    id: 3,
    name: '人力资源管理',
    subtitle: 'HUMAN RESOURCES',
    description: '提供人力资源规划、招聘培训、绩效考核等专业服务，助力企业构建高效人才团队。',
    image: '/static/fuwu/fw3.png',
  },
  {
    id: 4,
    name: '造价咨询',
    subtitle: 'COST CONSULTING',
    description: '提供工程造价估算、预算编制、成本控制等服务，帮助客户实现投资效益最大化。',
    image: '/static/fuwu/fw4.png',
  },
  {
    id: 5,
    name: '招标代理',
    subtitle: 'BIDDING AGENCY',
    description: '提供招标方案设计、招标文件编制、评标组织等全过程招标代理服务，确保招投标公平公正。',
    image: '/static/fuwu/fw5.png',
  },
  {
    id: 6,
    name: '工程造价咨询',
    subtitle: 'ENGINEERING COST',
    description: '提供工程造价全流程咨询服务，包括投资估算、设计概算、施工图预算、竣工结算等。',
    image: '/static/fuwu/fw6.png',
  },
  {
    id: 7,
    name: '第三方评估咨询',
    subtitle: 'THIRD-PARTY EVALUATION',
    description: '提供独立第三方评估服务，包括项目后评价、绩效评估、风险评估等，为决策提供客观依据。',
    image: '/static/fuwu/fw7.png',
  }
]

export const mockCases = [
  {
    id: 1,
    name: '市医生活垃圾焚烧发电项目',
    category: '环卫工程',
    description: '城市生活垃圾焚烧发电项目规划与建设，日处理能力1000吨。',
    image: '/static/commpocmedia.jfif',
    location: '四川·成都',
    scale: '日处理1000吨',
    year: '2024'
  },
  {
    id: 2,
    name: '贵阳静脉产业园生活垃圾焚烧项...',
    category: '环卫工程',
    description: '贵阳静脉产业园垃圾焚烧发电项目，总投资12亿元。',
    image: '/static/commpocmedia.jfif',
    location: '贵州·贵阳',
    scale: '日处理800吨',
    year: '2023'
  },
  {
    id: 3,
    name: '贵阳海螺光伏产业一体化项目',
    category: '产业园区',
    description: '光伏产业一体化项目，涵盖硅材料、电池片、组件全产业链。',
    image: '/static/commpocmedia.jfif',
    location: '贵州·贵阳',
    scale: '年产5GW',
    year: '2024'
  },
  {
    id: 4,
    name: '南平生活垃圾发电厂',
    category: '环卫工程',
    description: '南平市生活垃圾焚烧发电厂，采用先进环保技术。',
    image: '/static/commpocmedia.jfif',
    location: '福建·南平',
    scale: '日处理600吨',
    year: '2022'
  },
  {
    id: 5,
    name: '民权县生活垃圾焚烧发电项目',
    category: '环卫工程',
    description: '民权县垃圾焚烧发电项目，助力县域环境治理。',
    image: '/static/commpocmedia.jfif',
    location: '河南·商丘',
    scale: '日处理400吨',
    year: '2023'
  },
  {
    id: 6,
    name: '贵阳静脉产业园生活垃圾焚烧项...',
    category: '环卫工程',
    description: '贵阳静脉产业园二期垃圾焚烧发电项目。',
    image: '/static/commpocmedia.jfif',
    location: '贵州·贵阳',
    scale: '日处理1000吨',
    year: '2024'
  },
  {
    id: 7,
    name: '市政·保利D地块建设项目',
    category: '典型案例',
    description: '城市核心区域综合开发项目，涵盖住宅、商业、办公等多业态。',
    image: '/static/commpocmedia.jfif',
    location: '四川·成都',
    scale: '总建筑面积80万㎡',
    year: '2025'
  },
  {
    id: 8,
    name: '贵阳静脉产业园生活垃圾焚烧项...',
    category: '环卫工程',
    description: '静脉产业园垃圾焚烧发电三期扩建项目。',
    image: '/static/commpocmedia.jfif',
    location: '贵州·贵阳',
    scale: '日处理1200吨',
    year: '2025'
  },
  {
    id: 9,
    name: '固废处理综合利用项目',
    category: '固废治理',
    description: '固体废物综合处理与资源化利用项目，实现废弃物循环利用。',
    image: '/static/commpocmedia.jfif',
    location: '广东·广州',
    scale: '年处理30万吨',
    year: '2024'
  },
  {
    id: 10,
    name: '品牌策划与品牌建设咨询项目',
    category: '品牌建设',
    description: '为企业提供品牌战略规划、品牌形象设计、品牌传播等一站式服务。',
    image: '/static/commpocmedia.jfif',
    location: '北京',
    scale: '服务50+企业',
    year: '2024'
  },
  {
    id: 11,
    name: '石漠化综合治理示范项目',
    category: '石漠化工',
    description: '喀斯特地区石漠化综合治理，恢复生态环境与发展特色产业相结合。',
    image: '/static/commpocmedia.jfif',
    location: '贵州·毕节',
    scale: '治理面积50km²',
    year: '2023'
  },
  {
    id: 12,
    name: '基础设施投资运营PPP项目',
    category: '投资运营',
    description: '城市基础设施PPP项目投资与运营，涵盖道路、桥梁、管网等。',
    image: '/static/commpocmedia.jfif',
    location: '四川·成都',
    scale: '总投资50亿元',
    year: '2024'
  },
  {
    id: 13,
    name: '现代农业产业园建设项目',
    category: '农林土地',
    description: '现代农业产业园规划与建设，推动一二三产业融合发展。',
    image: '/static/commpocmedia.jfif',
    location: '山东·寿光',
    scale: '占地10000亩',
    year: '2023'
  },
  {
    id: 14,
    name: '智慧城市数字化平台建设',
    category: '数智案例',
    description: '智慧城市综合管理平台，涵盖城市治理、公共服务、产业发展等领域。',
    image: '/static/commpocmedia.jfif',
    location: '广东·深圳',
    scale: '覆盖100万人口',
    year: '2024'
  },
  {
    id: 15,
    name: '城市污水处理厂扩建项目',
    category: '固废治理',
    description: '城市污水处理厂扩建及提标改造工程，日处理能力由20万吨提升至40万吨。',
    image: '/static/commpocmedia.jfif',
    location: '江苏·苏州',
    scale: '日处理40万吨',
    year: '2024'
  },
  {
    id: 16,
    name: '大型商业综合体投资项目',
    category: '投资运营',
    description: '大型商业综合体投资开发与运营管理，总建筑面积30万平方米。',
    image: '/static/commpocmedia.jfif',
    location: '上海',
    scale: '总投资80亿元',
    year: '2025'
  }
]

export const mockCaseDetail = {
  id: 7,
  name: '市政·保利D地块建设项目',
  category: '典型案例',
  location: '四川·成都',
  scale: '总建筑面积80万㎡',
  year: '2025',
  client: '保利地产',
  image: '/static/commpocmedia.jfif',
  content: `此为市政·保利D地块项目案例，项目团队依托丰富的城市综合体开发经验，以专业、严谨、高效的工作态度，为客户提供从前期策划到后期运营的全过程咨询服务。

保利地产作为行业领先的房地产开发商，在项目规划、设计、施工、营销等环节均有独到见解。本项目位于成都市核心区域，地理位置优越，交通便利，周边配套完善。项目总建筑面积约80万平方米，涵盖高端住宅、精品商业、甲级写字楼、城市综合体等多种业态。

项目团队为客户提供了包括市场调研、项目定位、产品规划、成本控制、进度管理、质量监督等全方位的咨询服务。通过科学的管理方法和丰富的实践经验，确保了项目的高质量交付。

项目亮点：
1. 人性化的产品设计，注重居住舒适度与功能性；
2. 智能化社区管理系统，打造智慧生活体验；
3. 绿色建筑标准，符合可持续发展理念；
4. 完善的商业配套，满足居民多样化需求。

该项目的成功实施，不仅为成都市的城市建设增添了一道亮丽的风景线，也为同类项目的开发提供了宝贵的经验借鉴。`,
  tags: ['城市综合体', '高端住宅', '商业地产']
}

export const mockAbout = {
  companyName: '新恒丰集团',
  description: '新恒丰集团是一家专注于工程咨询、投资咨询、管理咨询的综合性咨询服务机构。公司秉承"服务经济社会高质量发展，助力科学决策，智谋投资价值"的使命，致力于为政府、企业和社会提供专业、高效、创新的咨询服务。',
  history: [
    { year: '1998', event: '公司成立，专注工程咨询业务' },
    { year: '2005', event: '拓展投资咨询服务领域' },
    { year: '2012', event: '获得国家甲级咨询资质' },
    { year: '2018', event: '启动数字化转型战略' },
    { year: '2024', event: '成为行业领先的综合性咨询机构' }
  ],
  stats: [
    { label: '服务项目', value: '2000+' },
    { label: '专业团队', value: '500+' },
    { label: '服务区域', value: '30+' },
    { label: '资质荣誉', value: '100+' }
  ]
}

export const mockPartners = [
  '/static/commpocmedia.jfif',
  '/static/commpocmedia.jfif',
  '/static/commpocmedia.jfif',
  '/static/commpocmedia.jfif',
  '/static/commpocmedia.jfif',
  '/static/commpocmedia.jfif'
]
